<template>
  <div class="test">
    <div class="wrapper">
      <h2>Тестовое задание от PROFIT agency</h2>

      <div class="test-text">

        <div class="test-text__name">Задание:</div>

        <p class="test-text__p">
          Сверстать по макету в Figma шапку сайта (без адаптива и скриптов).
        </p>

        <p class="test-text__p">
          <a href="/test/profit/index.html" title="" target="_blank">Итог выполнения</a>
        </p>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "profit",

  data () {
    return {

    }
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .test {
    position: relative;
    margin: 30px 0 0;
  }

  .test-text {
    position: relative;

    &__name {
      margin: 20px 0 0;
      text-align: center;
      font-size: 16px;
      font-weight: bold;

      @media screen and (min-width: 768px){
        text-align: left;
      }
    }

    &__p {
      margin: 25px 0 0;
      padding: 0;
    }
  }

</style>
